/**
 * Client trade licence: AI extraction (nothing is stored) and the licence profile
 * (contract: thaklis-doc 28-organization-documents SPEC.md §5).
 */

import ApiService from '../api.service';
import { unwrapData, keysCamelToSnake } from '../../utils/apiConvert';

const BASE = '/api/internal-organizations';

export const tradeLicenceService = {
  // number, dates and (trade licence only) the full licence of any company document type (nothing is saved)
  extractDocument: async (file, documentType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_type', documentType);
    return unwrapData(await ApiService.post(`${BASE}/documents/extract`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }));
  },

  // the licence fields of a trade licence file
  extract: async (file) => (await tradeLicenceService.extractDocument(file, 'TRADE_LICENSE'))?.licence,

  // the client's licence profile, or null when it has none
  get: async (orgId) => unwrapData(await ApiService.get(`${BASE}/${orgId}/trade-licence`)),

  // creates or replaces the profile; an empty body clears it
  save: async (orgId, payload) => unwrapData(
    await ApiService.put(`${BASE}/${orgId}/trade-licence`, keysCamelToSnake(payload)),
  ),
};
